import type { SVGProps } from 'react';

export type IconName = 'desk' | 'topic' | 'place' | 'bookmark' | 'bell' | 'settings' | 'admin' | 'search' | 'logout' | 'plus' | 'arrow' | 'pulse' | 'close' | 'map' | 'filter' | 'clock' | 'eye' | 'warning';

const paths: Record<IconName, React.ReactNode> = {
  desk: <><path d="M4 5h16v14H4z"/><path d="M8 9h8M8 13h5"/></>,
  topic: <><circle cx="12" cy="12" r="8"/><path d="M12 8v8M8 12h8"/></>,
  place: <><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2"/></>,
  bookmark: <path d="M6 3h12v18l-6-4-6 4z"/>,
  bell: <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7"/><path d="M10 19h4"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1A7 7 0 0 0 15 6l-.3-2.6h-4L10.4 6a7 7 0 0 0-1.5.9l-2.4-1-2 3.4 2 1.5a7 7 0 0 0 0 2.2l-2 1.5 2 3.4 2.4-1a7 7 0 0 0 1.5.9l.3 2.6h4l.3-2.6a7 7 0 0 0 1.5-.9l2.4 1 2-3.4-2-1.5a7 7 0 0 0 .1-1Z"/></>,
  admin: <><path d="M12 3 4 7v5c0 5 3.5 8 8 9 4.5-1 8-4 8-9V7z"/><path d="m9 12 2 2 4-5"/></>,
  search: <><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></>,
  logout: <><path d="M10 5H5v14h5M14 8l4 4-4 4M18 12H9"/></>,
  plus: <path d="M12 5v14M5 12h14"/>,
  arrow: <path d="m9 18 6-6-6-6"/>,
  pulse: <path d="M3 12h4l2-6 4 12 2-6h6"/>,
  close: <path d="m6 6 12 12M18 6 6 18"/>,
  map: <><path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3z"/><path d="M9 3v15M15 6v15"/></>,
  filter: <path d="M4 6h16M7 12h10M10 18h4"/>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  eye: <><path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12Z"/><circle cx="12" cy="12" r="2.5"/></>,
  warning: <><path d="M12 3 2.8 20h18.4Z"/><path d="M12 9v5M12 17.3h.01"/></>,
};

export type IconProps = SVGProps<SVGSVGElement> & { name: IconName };

export function Icon({ name, ...props }: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name]}</svg>;
}
